import * as Yup from 'yup';

const schemaObservation = () => {
  return Yup.object().shape({
    message: Yup.string().required()
  });
};

export default schemaObservation;
